import { defineComponent as _defineComponent } from 'vue'
import { getValueByStatus } from "@/helpers/customer";
  import { DetailsLot } from "@/types/CustomerLotDetails";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDetailsCardLot',
  props: {
    data: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get getValueByStatus() { return getValueByStatus }, get DetailsLot() { return DetailsLot } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})